module.exports = __webpack_public_path__ + "img/mob_step_img.bcd6e50e.png";